import {useHovercardAttributesForUser} from '@github-ui/hovercards/user'
import {RepoIcon} from '@primer/octicons-react'
import {Label, Link} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {clsx} from 'clsx'
import type {FC} from 'react'
import {graphql, useFragment} from 'react-relay'

import {LABELS} from '../../constants/labels'
import type {RepositoryPill$key} from './__generated__/RepositoryPill.graphql'
import styles from './RepositoryPill.module.css'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const RepositoryPillFragment = graphql`
  fragment RepositoryPill on Issue {
    repository {
      name
      owner {
        login
      }
      isPrivate
    }
  }
`

export type RepositoryPillProps = {
  repositoryPillData: RepositoryPill$key
  className?: string
  isSmall?: boolean
}

export const SmallRepositoryPill: FC<RepositoryPillProps> = props => <RepositoryPill {...props} isSmall />

export function RepositoryPill({repositoryPillData, className, isSmall = false}: RepositoryPillProps) {
  const {repository} = useFragment(RepositoryPillFragment, repositoryPillData)
  const repoOwner = repository.owner.login
  const repoName = repository.name
  const hovercardAttrs = useHovercardAttributesForUser({login: repoOwner})

  const link = (
    <div className={clsx(styles.repositoryInfoContainer, !isSmall && styles.repositoryInfoContainerLarge)}>
      {!isSmall && <Octicon icon={RepoIcon} className={styles.repositoryIcon} />}{' '}
      {/* 2px to achieve visual alignment */}
      <Link href={`/${repoOwner}`} {...hovercardAttrs} className={styles.ownerLink}>
        {repoOwner}
      </Link>
      <span>/</span>
      <Link href={`/${repoOwner}/${repoName}`} className={styles.repositoryNameLink}>
        {repoName}
      </Link>
    </div>
  )

  if (isSmall) {
    return link
  }

  return (
    <div className={clsx(styles.smallRepositoryPill, className)}>
      {link}
      <Label size="small" data-watch-overflow className={styles.repositoryLabel}>
        {repository.isPrivate ? LABELS.private : LABELS.public}
      </Label>
    </div>
  )
}
